<button
    name="visibilitySettings"
    id="visibilitySettingsToolBtn"
    class="apply-visibility-settings"
    [title]="getTooltip()"
    (click)="toggleWidgetVisibility()"
    [disabled]="isDisabled()">
    <i
        class="nlrp-icon nlrp-icon-settings"
        [ngClass]="{'apply-visibility-settings-all-pages': !applyVisibilityThisPageOnly()}"></i>
</button>
@if (isWidgetActive()) {
    <div
        id="visibilitySettings"
        class="widget container-fluid well"
        cdkDrag
        [cdkDragConstrainPosition]="computeDragPosition"
        style="visibility: hidden"
        #widget>
        <form
            id="visibilitySettingsForm"
            name="visibilitySettingsForm"
            novalidate
            autocomplete="off"
            #visibilitySettingsForm="ngForm">
            <div
                class="col-xs-12 widget-header"
                cdkDragHandle>
                <span>{{widgetConfig.header}}</span>
                <div class="pull-right btn-group btn-group-xs">
                    <nlrp-help-link
                        [url]="helpLinkUrl"
                        [pageTitle]="helpPageTitle"></nlrp-help-link>
                    <i
                        class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                        [title]="widgetConfig.closeTooltip"
                        (click)="toggleWidgetVisibility()"></i>
                </div>
            </div>
            <div class="widget-content">
                <div class="mgt10">
                    <div class="col-xs-12">
                        @for (option of visibilityOptions; track option) {
                            <label
                                class="nlr-radio"
                                [title]="option.toolTip">
                                <input
                                    type="radio"
                                    name="visibilitySetting"
                                    id="visibilitySetting"
                                    [value]="option.value"
                                    [(ngModel)]="visibilitySelected"
                                    (ngModelChange)="visibilityChanged()"
                                    required />
                                <span>{{option.displayValue}}</span>
                            </label>
                        }
                    </div>
                </div>
            </div>
        </form>
    </div>
}
